(function() {
    'use strict';

    angular
        .module('liverunApp')
        .controller('QuestionAnswerDetailController', QuestionAnswerDetailController);

    QuestionAnswerDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'QuestionAnswer', 'Runner', 'RaceQuestion'];

    function QuestionAnswerDetailController($scope, $rootScope, $stateParams, previousState, entity, QuestionAnswer, Runner, RaceQuestion) {
        var vm = this;

        vm.questionAnswer = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('liverunApp:questionAnswerUpdate', function(event, result) {
            vm.questionAnswer = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
